<template>
    <div class="container-xxl padding-container-matrix">
        <div class="row justify-content-center">
            <div class="col-matrix">
                <div class="row">
                    <div class="col-12 col-lg-7 mb-5 mb-lg-0">
                        <div v-if="el.img !== null">
                            <AssetLoader :asset="{ asset: el.img.imageID }" />
                        </div>
                    </div>
                    <div class="col-12 col-lg-5">

                        <div class="card-details">
                            <div class="card-header">
                                <h6 v-if="el.blockTitle !== ''" class="mb-4 bold">{{el.blockTitle}}</h6>
                            </div>
                            <div class="card-body">
                                <div v-if="el.textContent !== ''" class="text-editor" v-html="el.textContent"></div>
                            </div>

                            <div v-if="el.blockLink.length > 0" class="card-footer mt-5">

                                <div v-if="el.blockLink[0].type === 'url'">
                                    <a :href="el.blockLink[0].value" class="button" :target="el.blockLink[0].target">{{el.blockLink[0].customText}}</a>
                                </div>
                                <div v-if="el.blockLink[0].type === 'email'">
                                    <a :href="'mailto:' + el.blockLink[0].value" class="button" target="_blank">{{el.blockLink[0].customText}}</a>
                                </div>
                                <div v-if="el.blockLink[0].type === 'entry'">
                                    <a :href="el.blockLink[0].value.fr" class="button" :target="el.blockLink[0].target">{{el.blockLink[0].customText}}</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import AssetLoader from '@/components/helpers/AssetLoader'

export default {
    name: 'infoCardWithImage',
    components: {
        AssetLoader
    },
    props: {
        el: {
            type: Object,
            required: true,
        },
    },
    computed: {
        pageIsLoaded() {
            return this.contentIsLoaded && this.globalsIsLoaded
        },
        ...mapState(['contentIsLoaded', 'globalsIsLoaded']),
        ...mapGetters(['seo', 'content', 'globals']),
    },
    methods: {
        ...mapActions(['setErrorsReportMsg']),
    },
    // On loaded...
    mounted() {},
}
</script>
